export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'AccountReceivables';
export const NAME = 'AccountReceivables';
